export type AiCaptainPage =
  | 'restaurant'
  | 'menu_list'
  | 'item_detail'
  | 'cart'
  | 'my_orders';

export interface AiCaptainPageContext {
  page: AiCaptainPage;
  context: Record<string, string | undefined>;
}

/** Derive Peppy AI page + context from React Router pathname. */
export function resolveAiCaptainPageContext(pathname: string): AiCaptainPageContext | null {
  const base = pathname.match(/^\/restaurants\/([^/]+)(?:\/(.*))?$/);
  if (!base) return null;

  const rest = base[2] ?? '';

  if (!rest) {
    return { page: 'restaurant', context: {} };
  }
  if (rest === 'menu') {
    return { page: 'menu_list', context: {} };
  }
  if (rest.startsWith('menu/')) {
    const itemUrl = rest.slice('menu/'.length).split('/')[0];
    return { page: 'item_detail', context: { itemUrl } };
  }
  if (rest === 'cart') {
    return { page: 'cart', context: {} };
  }
  if (rest === 'my-orders' || rest.startsWith('orders/')) {
    const orderMatch = rest.match(/^orders\/(\d+)/);
    return {
      page: 'my_orders',
      context: orderMatch ? { orderId: orderMatch[1] } : {},
    };
  }

  return { page: 'restaurant', context: {} };
}
